const LT = {
  partnershipIncorporated: [
    "komanditinės ūkinės bendrijos (KUB)",
    "mažoji bendrija (MB)"
  ],
  partnershipUnincorporated: [
    "tikrosios ūkinės bendrijos (TUB)"
  ]
};
export {
  LT as default
};
